import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { LinearProgress } from '@mui/material';
import classnames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';

/**
 * A progress bar is a graphical control element used to visualize the progression of an extended computer operation, such as a download, file transfer, or installation.
 */
var ProgressBar = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    inverted = _a.inverted,
    value = _a.value,
    otherProps = __rest(_a, ["className", "inverted", "value"]);
  return jsx("div", Object.assign({
    className: classnames.apply(undefined, ['cogs-lab', 'cogs-lab-progressbar'].concat(_toConsumableArray(getThemeClassNames(inverted)), [className]))
  }, otherProps, {
    children: jsx(LinearProgress, {
      ref: ref,
      variant: "determinate",
      value: value
    })
  }));
});

export { ProgressBar };
